import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-capture-comment-modal',
  templateUrl: './capture-comment-modal.component.html',
  styleUrls: ['./capture-comment-modal.component.scss']
})
export class CaptureCommentModalComponent implements OnInit {
  @Input() modalTitle = 'Update Tracking Url';
  @Input() submitTitle = 'Submit';
  formGroup: FormGroup;
  comment: string;
  @Input() id: number;
  amcoId: number;
  url: string;

  constructor(
    public dialogRef: MatDialogRef<CaptureCommentModalComponent>,
    public builder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.createForm();
    this.id = data.id;
    this.amcoId = data.amcoId;
    this.url = data.url;
    // this.parcel = data.parcel;
  }

  ngOnInit(): void {
    this.formGroup.patchValue({ comment: this.url });
  }

  back(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close({ data: this.formGroup.value.comment });
  }

  createForm() {
    this.formGroup = this.builder.group({
      comment: new FormControl('', [Validators.required])
    });
  }
}
